import React, { useState } from "react";
import "./FloatingContactButton.css";
import WhatsAppIcon from "../../Assets/Images/Icons/ConnectUsonWhatsapp.webp";
import { FaPhoneAlt, FaTimes, FaCopy } from "react-icons/fa";

const FloatingContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumbers = [
    { number: "+91 88281 03808" },
    { number: "+91 91678 71033" },
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      const toast = document.createElement("div");
      toast.innerText = `Copied: ${text}`;
      toast.style.position = "fixed";
      toast.style.bottom = "100px";
      toast.style.left = "50%";
      toast.style.transform = "translateX(-50%)";
      toast.style.background = "#333";
      toast.style.color = "#fff";
      toast.style.padding = "8px 14px";
      toast.style.borderRadius = "8px";
      toast.style.fontSize = "13px";
      toast.style.zIndex = "9999";
      toast.style.opacity = "0";
      toast.style.transition = "opacity 0.3s";

      document.body.appendChild(toast);
      setTimeout(() => (toast.style.opacity = "1"), 100);
      setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 300);
      }, 2000);
    });
  };

  return (
    <>
      <button className="floating-btn" onClick={() => setIsOpen(!isOpen)}>
        <FaPhoneAlt />
      </button>

      {isOpen && (
        <div className="contact-popup">
          <div className="contact-header">
            <h4>Contact Us</h4>
            <FaTimes className="close-icon" onClick={() => setIsOpen(false)} />
          </div>
          <p>Reach out to us at the numbers below:</p>
          <ul className="contact-list">
            {phoneNumbers.map(({ label, number }) => (
              <li key={number}>
                <a href={`tel:${number}`}>{number}</a>
                <FaCopy
                  className="copy-icon"
                  onClick={() => copyToClipboard(number)}
                />
              </li>
            ))}
          </ul>
          {/* <div className="contact-whatsapp-image">
            <a
              href="https://api.whatsapp.com/send?phone=+918828103808&text=Hello"
              target="_blank"
            >
              <img src={WhatsAppIcon} alt="" width="50%" />
            </a>
          </div> */}
        </div>
      )}
    </>
  );
};

export default FloatingContactButton;
